import React from 'react'
import { func, string, bool } from 'prop-types'
import { Button, Dialog, Illustration } from '@cobalt/cobalt-react-components'
import ContentHeader from '../ContentHeader'
import Error from '../Error'

const ConfirmDialog = ({
  onDismiss,
  onConfirm,
  dismissText,
  confirmText,
  title,
  subtitle,
  errorMessage,
  isConfirmDisabled,
  isCancelDisabled,
  cancelState,
  confirmState
}) => (
  <Dialog>
    <Dialog.Content>
      <Illustration name={Illustration.EXCLAMATION} />
      <Error message={errorMessage} />
      <ContentHeader title={title} message={subtitle} />
      <Dialog.Actions>
        <Button
          basic
          secondary
          onClick={onDismiss}
          disabled={isCancelDisabled}
          state={cancelState}
        >
          {dismissText}
        </Button>
        <Button
          basic
          danger
          onClick={onConfirm}
          disabled={isConfirmDisabled}
          state={confirmState}
        >
          {confirmText}
        </Button>
      </Dialog.Actions>
    </Dialog.Content>
  </Dialog>
)

ConfirmDialog.propTypes = {
  onDismiss: func.isRequired,
  onConfirm: func.isRequired,
  dismissText: string,
  confirmText: string,
  title: string.isRequired,
  subtitle: string.isRequired,
  errorMessage: string,
  isConfirmDisabled: bool,
  isCancelDisabled: bool,
  cancelState: string,
  confirmState: string
}

ConfirmDialog.defaultProps = {
  isCancelDisabled: false,
  isConfirmDisabled: false
}

export default ConfirmDialog
